import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from 'react';
import Video from '../useVideoinfo/Videoinfo';

var useVideo = function useVideo(videoId, videoType) {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      videoInfo = _React$useState2[0],
      setVideoInfo = _React$useState2[1];

  React.useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var vid, newVideoInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!videoId) {
                  setVideoInfo(null);
                }

                vid = new Video(videoId, videoType);
                newVideoInfo = null;
                _context.prev = 3;
                _context.next = 6;
                return vid.getInfo();

              case 6:
                newVideoInfo = {
                  thumbnail: vid.getThumbnail(),
                  regular: vid.getRegular(),
                  videoTypeName: vid.getVideoTypeName(),
                  link: vid.getLink()
                };
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                newVideoInfo = {};

              case 12:
                setVideoInfo(newVideoInfo);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 9]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData();
  }, [videoId, videoType]);
  return videoInfo;
};

export default useVideo;